import axios, { AxiosPromise } from 'axios';
import { IUser } from '../../../@types/model/right/user/userModel';
import { IUserUpsert } from '../../../@types/model/right/user/userUpsert';
import { IUserToken } from '../../../@types/model/right/userToken/userTokenModels';


export default class UserHttpService {
    private static readonly PATH = '/User'

    public static get = async (userId : number, signal ?: AbortSignal) : Promise<IUser> => {
        const result = await axios.get(`${API_URL}/v1/User/Get`, {
            params: {
                userId
            },
            signal
        });
        return result.data;
    }

    public static getList = async (signal ?: AbortSignal) : Promise<Array<IUser>> => {
        const result = await axios.get(`${API_URL}/v1/User/GetList`, {
            signal
        });
        return result.data;
    }

    public static upsert = async (upsertData : Array<IUserUpsert>) : Promise<Array<IUser>> => {
        const result = await axios.post(`${API_URL}/v1/User/Upsert`, upsertData);
        return result.data;
    }

    public static setEmployeeNumber = (employeeNumber : string) : AxiosPromise<IUserToken> => {
        return axios.post(`${API_URL}/v1/User/SetEmployeeNumber`, null, {
            params: {
                employeeNumber,
            },
        });
    }

    public static linkGoogleAccount = async (code : string) : Promise<void> => {
        return await axios.post(`${API_URL}/v1/User/LinkGoogleAccountToUser`, {
            code
        });
    }

    public static unlinkEmail = async () : Promise<void> => {
        return await axios.post(`${API_URL}/v1/User/UnlinkGoogleAccountFromUser`);
    }

    public static updateEmployeeCredentials = async () : Promise<void> => {
        return await axios.post(`${API_URL}/v1/User/UpdateEmployeeCredentials`);
    }

    public static resetEmployeeCredentials = async () : Promise<void> => {
        return await axios.post(`${API_URL}/v1/User/ResetEmployeeCredentials`);
    }

    public static logout = () : AxiosPromise => {
        return axios.post(`${API_URL}/v1${this.PATH}/LogoutUser`);
    }

    public static logoutUsers = async (userIds : Array<number>) : Promise<void> => {
        await axios.post(`${API_URL}/v1${this.PATH}/LogoutUsers`, userIds);
    }

    public static logoutAllUsers = async () : Promise<void> => {
        await axios.post(`${API_URL}/v1${this.PATH}/LogoutAllUsers`);
    }

    public static requestForgottenPasswordEmail(email : string) : AxiosPromise<void> {
        return axios.post(`${API_URL}/v1${this.PATH}/RequestPasswordReset`, null, {
            params: {
                email,
            }
        });
    }

    public static resetPassword(oldPassword : string, newPassword : string, recoveryCode : string) : AxiosPromise<boolean> {
        return axios.post(`${API_URL}/v1${this.PATH}/ResetUserPassword`, null, {
            params: {
                oldPassword,
                newPassword,
                recoveryCode,
            }
        });
    }

    public static userDelete = (userId : number) : Promise<void> => {
        return axios.delete(`${API_URL}/v1${this.PATH}/Delete`, {
            params: { userId },
        });
    }
}
